import {useContext, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import { PartnerContext } from '../PartnerContexts'

const EditGrupoModalHeader = () => {
  const {setEditOpenShowModal} = useContext(PartnerContext)
  const [title, setTitle] = useState('')

  useEffect(() => {
    setTitle('Agregar')
  }, [])

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Crear Grupo Aprobación</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => setEditOpenShowModal(false)}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export {EditGrupoModalHeader}
